var _path, _path2, _path3, _path4, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiMenuTravel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5136 32.7621C18.2862 32.9152 17.2816 31.7993 17.5622 30.5947L18.898 24.8609L28.0982 21.194L20.7643 31.9966C20.477 32.4199 20.0212 32.6988 19.5136 32.7621Z",
    fill: "#5C5B5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4774 8.24897C13.16 7.55961 12.126 7.26175 11.1915 8.23197C10.2571 9.20219 10.3185 10.0563 11.1543 11.2244L16.5252 17.7829L13.939 19.0444L13.9419 19.0357L8.51203 18.3829C7.88283 18.2491 7.23688 18.483 6.82875 18.9923C6.2259 19.7447 6.38874 20.7773 7.02729 21.5184C7.66583 22.2596 10.6835 24.6806 11.449 25.3421C12.2146 26.0035 14.0714 27.0596 15.5574 26.4555L31.9179 19.8047C33.7661 19.0534 35.4206 16.868 34.3534 14.1153C33.2862 11.3626 30.152 11.3518 28.3038 12.1031L24.4157 13.6837L14.4774 8.24897Z",
    fill: "#D1CFCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4774 8.24894C13.16 7.55958 12.126 7.26172 11.1915 8.23194C10.257 9.20216 10.3184 10.0563 11.1543 11.2244L16.5252 17.7828L24.4156 13.6836L14.4774 8.24894Z",
    fill: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1451_18350",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 29,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4774 8.24897C13.16 7.55961 12.126 7.26175 11.1915 8.23197C10.2571 9.20219 10.3185 10.0563 11.1543 11.2244L16.5252 17.7829L13.939 19.0444L13.9419 19.0357L8.51203 18.3829C7.88283 18.2491 7.23688 18.483 6.82875 18.9923C6.2259 19.7447 6.38875 20.7773 7.02729 21.5184C7.66583 22.2596 10.6835 24.6806 11.449 25.3421C12.2146 26.0035 14.0714 27.0596 15.5574 26.4555L31.9179 19.8047C33.7661 19.0534 35.4206 16.868 34.3534 14.1153C33.2862 11.3626 30.152 11.3518 28.3038 12.1031L24.4157 13.6837L14.4774 8.24897Z",
    fill: "url(#paint0_linear_1451_18350)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1451_18350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.333 19.5834L9.16638 24.5834L16.6664 28.75L33.333 19.5834Z",
    fill: "#FF791C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4702 15.2398L33.5668 13.778",
    stroke: "#ECECEC",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1451_18350",
    x1: 12.805,
    y1: 10.9908,
    x2: 29.3619,
    y2: 19.0321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29D1FC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiMenuTravel);
export default __webpack_public_path__ + "static/media/wikiMenuTravel.ab31162b37ee4b7d090a23e49eec848f.svg";
export { ForwardRef as ReactComponent };